import { SubscriptionInfoCard } from '@aibees/shared/components';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { classnames, fDate, fNumber } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { AccountPopoverSubscriptionPlanProps as Props } from './types';

export const AccountPopoverSubscriptionPlan = memo(({ className }: Props) => {
  const { data } = useCurrentSubscriptionApi();

  return (
    <Styled.Wrapper
      className={classnames('AccountPopoverSubscriptionPlan', className)}
      gap={1}
    >
      {data?.next && (
        <SubscriptionInfoCard
          isFree={data.next.plan?.metadata.is_free === 'true'}
          interval={data?.next?.plan?.interval}
          amount={fNumber(data?.next?.plan?.metadata.request || 0)}
          startDate={fDate(data.next.startDate, 'dd/MM/yyyy')}
        />
      )}
      <SubscriptionInfoCard
        interval={data?.current?.plan?.interval}
        amount={fNumber(data?.current?.plan?.metadata.request || 0)}
        isCurrent
        title={
          data?.current?.plan?.metadata.is_free
            ? 'Free Plan'
            : 'Usage-Based Plan'
        }
      />
    </Styled.Wrapper>
  );
});

AccountPopoverSubscriptionPlan.displayName = 'AccountPopoverSubscriptionPlan';
